/* eslint-disable */
import {PageManager} from '@mvps-genesis/core';

// Extensions
import EventBus from '@mvps-genesis/event-bus';
import {waitForExpression} from '@mvps-genesis/utilities';
import FormModal from 'Extensions/form-modal';
import jtabs from 'Extensions/jtabs';
import klaviyoAddToCartTracking from 'Extensions/klaviyo-add-to-cart-tracking';
import QuantityAdjust from 'Extensions/quantity-adjustment';
import ringSizer from 'Extensions/ring-sizer';
import {addToCartTracking, ratingTracking} from 'extensions/hawksearch/pages/global';
import 'extensions/my-registry';
import 'extensions/waitlist-signup';

// Plugins
import 'Plugins/sticky-fill.js';
import 'Plugins/toggle-disabled.js';
import 'tooltipster';

// Auto close after 10 seconds
const MINI_BASKET_AUTOCLOSE_TIME = 10000;
const MINI_BASKET_AUTOCLOSE_AFTER_HOVER_TIME = 3000;

export default class PROD extends PageManager {

	constructor(pageContext) {
		super(pageContext);

		if (pageContext?.ringBuilder?.showInRingBuilder) {
			import('extensions/ring-builder');
		}
	}

	onReady() {
		const self = this;

		self.productImageGallery();
		self.prodFamilyQuantityAdjust();
		self.tooltip();
		self.familyAddToCart();
		self.addToCart();
		self.imagemachineFallback();
		self.prodLoad();
		self.variantChange();
		self.outOfStock();
		self.callToOrder();
		self.wishlistButtons();
		jtabs();
		self.dropAHint();
		self.productDetailsForm();
		ringSizer();

		self.siteVibes();

		self.sizeChartModals();

		self.promoBannerModal();
	}

	promoBannerModal () {
		const triggerElement = document.getElementById('js-promo-banner-cta');
		const modalElement = document.getElementById('js-promo-banner-modal');

		if (triggerElement && modalElement) {
			$(triggerElement).magnificPopup({
				mainClass: 'promo-banner-component__modal-container',
				items: {
					type: 'inline',
					src: $(modalElement)
				}
			});
		}
	}

	sizeChartModals () {
		this.earringSizeChartModal();
		this.tennisSizeChartModal();
		this.studsSizeChartModal();
		this.ringBandWidthSizeChartModal();
	}

	earringSizeChartModal () {
		const trigger = document.getElementById('js-earring-size-chart-trigger');
		const content = document.getElementById('js-earring-size-chart');

		if (trigger && content) {
			$(trigger).magnificPopup({
				mainClass: 'x-earring-size-chart-popup',
				items: {
					type: 'inline',
					src: '#js-earring-size-chart'
				}
			});
		}
	}

	tennisSizeChartModal () {
		const trigger = document.getElementById('js-tennis-size-chart-trigger');
		const content = document.getElementById('js-tennis-size-chart');

		if (trigger && content) {
			$(trigger).magnificPopup({
				mainClass: 'x-tennis-size-chart-popup',
				items: {
					type: 'inline',
					src: '#js-tennis-size-chart'
				}
			});
		}
	}

	studsSizeChartModal () {
		const trigger = document.getElementById('js-studs-size-chart-trigger');
		const content = document.getElementById('js-studs-size-chart');

		if (trigger && content) {
			$(trigger).magnificPopup({
				mainClass: 'x-studs-size-chart-popup',
				items: {
					type: 'inline',
					src: '#js-studs-size-chart'
				}
			});
		}
	}

	ringBandWidthSizeChartModal () {
		const trigger = document.getElementById('js-ring-size-chart-trigger');
		const content = document.getElementById('js-ring-size-chart');

		if (trigger && content) {
			$(trigger).magnificPopup({
				mainClass: 'x-ring-size-chart-popup',
				items: {
					type: 'inline',
					src: '#js-ring-size-chart'
				}
			});
		}
	}

	siteVibesOpenReviewTab () {
		const accordionTabs = document.querySelectorAll('.accordion-tab');
		let accordionReviewTab = Array.prototype.filter.call(accordionTabs, function (item) {
			return item.innerHTML === 'Reviews'
		});
		if (accordionReviewTab.length > 0){
			accordionReviewTab = accordionReviewTab[0];
			document.querySelector('#sv-product-reviews-star-rating .sv-product-review-small__content').addEventListener('click', function () {
				if (!accordionReviewTab.classList.contains('accordion-active')) {
					accordionReviewTab.click();
				}
			});
		}
	}

	siteVibes () {
		const self = this;
		const siteVibesRatingWidget = document.querySelector('#js-sitevibes-star-rating-widget');
		if (siteVibesRatingWidget) {
			const observer = new MutationObserver(function(mutationsList, observer){
				for (const mutation of mutationsList) {
					const stars = mutation.target.querySelectorAll('.sv-product-review-star');
					if (stars.length > 0) {
						self.siteVibesOpenReviewTab();
						observer.disconnect();
					}
				}
			});

			observer.observe(siteVibesRatingWidget, {
				childList: true,
				subtree: true
			});
		}

		// Create event listener on rating form submit
		let siteVibesPostReviewButton;
		const assignSiteVibesPostReviewButton = () => {
			siteVibesPostReviewButton = document.querySelector('#sv-product-reviews .sv-product-review__form [type="submit"]');
			return siteVibesPostReviewButton;
		};

		waitForExpression(
			() => assignSiteVibesPostReviewButton(),
			() => {
				siteVibesPostReviewButton.addEventListener('click', (e) => {
					const selectedStar = document.querySelectorAll('#sv-product-reviews .sv-product-review__form .sv-product-review-star.sv-product-review-star--filled');
					const rating = selectedStar?.length? selectedStar.length : 0;
					if (rating > 0) {
						ratingTracking(window.mivaJS.Product_Code, rating);
					}
				});
		}
		);
	}


	prodFamilyQuantityAdjust () {
		if (window.mivaJS.Page_Code.toLowerCase() !== 'prod_family') {
			return;
		}

		new QuantityAdjust({
			increaseButton: $('.increase-quantity'),
			decreaseButton: $('.decrease-quantity'),
			min: 1
		});

		// Add Listeners for each family product's quantity, and push to the Registry component
		const familyItemElements = document.getElementsByClassName('js-family-product');
		for (const familyItemElement of familyItemElements) {
			const quantityElement = familyItemElement.querySelector('.js-family-product__quantity');
			const registryElement = familyItemElement.querySelector('.js-family-product__registry');

			if (!quantityElement || !registryElement) {
				continue;
			}

			quantityElement.addEventListener('change', () => {
				registryElement.setAttribute('quantity', parseInt(quantityElement.value, 10));
			});
		}
	}

	tooltip() {
		const $tooltips = $('.tooltip');

		if ($('.tooltip').length === 0) {
			return;
		}

		$tooltips.each(function() {
			$(this).tooltipster({
				theme: 'tooltipster-custom',
				trigger: 'hover'
			});
		});
	}

	familyAddToCart() {
		$('.family-cart--button').on('click', function(e) {
			const $purchaseForm = $(this).parents('form');
			if ($purchaseForm.data('formstatus') !== 'submitting') {
				const form = $purchaseForm;
				const formData = form.serialize();
				const formUrl = form.attr('action').replace('^https?:', '');
				const formMethod = form.attr('method');
				const responseMessage = $(this).parents('form').find('.family-purchase--msg');
				const miniBasket = document.querySelector('x-mini-basket');
				const purchaseButton = $(this);
				const purchaseButtonText = purchaseButton.val();

				form.data('formstatus', 'submitting');
				purchaseButton.toggleDisabled().val('Processing...');
				responseMessage.html('').hide();

				$.ajax({
					url: formUrl,
					type: formMethod,
					cache: false,
					data: formData,
					success: function(data) {
						if (data.search(/id="js-BASK"/i) != -1) {
							const responseMiniBasket = $(data).find('x-mini-basket')[0];
							const miniBasketCount = responseMiniBasket.getAttribute('count');
							const miniBasketSubtotal = responseMiniBasket.getAttribute('formatted-subtotal');
							const miniBasketCountElements = document.getElementsByClassName('js-mini-basket-count');
							for (const miniBasketCountElement of miniBasketCountElements) {
								miniBasketCountElement.innerText = miniBasketCount;
							}

							miniBasket.setAttribute('formatted-subtotal', miniBasketSubtotal);
							miniBasket.setAttribute('count', miniBasketCount);
							miniBasket.innerHTML = responseMiniBasket.innerHTML;

							responseMessage.addClass('green').html('<span class="maroon" data-icon="&#x4e;"></span> Item successfully added to the bag.').fadeIn().delay(3000).fadeOut().removeClass('green');

							if (typeof window.attrMachCall !== 'undefined') {
								attrMachCall.Initialize();
							}

							// Klaviyo Add To Cart Tracking
							if (responseMiniBasket.getAttribute('data-klaviyo-atc')) {
								const klaviyoData = JSON.parse(atob(responseMiniBasket.getAttribute('data-klaviyo-atc')));

								if (typeof window._learnq === 'object' && klaviyoData) {
									klaviyoAddToCartTracking(klaviyoData);
								}

								// GTM addToCart Event fired when Ajax is successful / Hawksearch tracking
								if (klaviyoData) {
									window.dataLayer.push({
										ecommerce: null
									});

									const urlParams = new URLSearchParams(window.location.search);
									const gtmList = urlParams.get('list');
									const slugify = (text) => {
										return text?.toLowerCase().replace(/[^\w- ]+/g, '').replace(/ +/g, '-');
									}

									window.dataLayer.push({
										event: 'add_to_cart',
										ecommerce: {
											add: {
												products: [
													{
														brand: klaviyoData.AddedItem_Brand,
														category: klaviyoData.AddedItem_Categories[0],
														id: klaviyoData.AddedItem_SKU,
														/* eslint-disable camelcase */
														item_brand: klaviyoData.AddedItem_Brand,
														item_id: klaviyoData.AddedItem_SKU,
														item_name: klaviyoData.AddedItemProductName,
														item_list_id: slugify(gtmList) || 'family-product-page',
														item_list_name: gtmList || 'family-product-page',
														item_category: klaviyoData.AddedItem_Categories[0],
														/* eslint-enable camelcase */
														name: klaviyoData.AddedItemProductName,
														currency: 'USD',
														price: klaviyoData.AddedItem_Price,
														quantity: klaviyoData.AddedItem_Quantity
													}
												]
											}
										},
										/* eslint-disable camelcase */
										ga_event_action: 'Add To Cart',
										ga_event_category: 'Ecommerce',
										ga_event_label: '',
										ga_event_noninteraction_hit: false,
										ga_event_value: ''
										/* eslint-enable camelcase */
									});

									// Hawksearch tracking
									addToCartTracking(klaviyoData.AddedItem_SKU, klaviyoData.AddedItem_Quantity, klaviyoData.AddedItem_Price);
								}
							}

						} else if (data.search(/id="js-PATR"/i) != -1) {
							let missingAttrs = [];
							form.find('.required').each(function() {
								missingAttrs.push(' ' + $(this).attr('title'));
							});
							responseMessage.html(`All <em class="red">Required</em> options have not been selected.<br />Please review the following options: <span class="red">${missingAttrs}</span>.`).fadeIn().delay(5000).fadeOut();
						} else if (data.search(/id="js-PLMT"/i) != -1) {
							responseMessage.html('We do not have enough stock to meet your request. Please adjust your quanity.').fadeIn().delay(3000).fadeOut();
						} else if (data.search(/id="js-POUT"/i) != -1) {
							responseMessage.html('The product you have selected is out of stock.<br />Please review your options or check back later.').fadeIn().delay(3000).fadeOut();
						} else {
							responseMessage.html('Please review options.').fadeIn().delay(3000).fadeOut();
						}

						purchaseButton.toggleDisabled().val(purchaseButtonText);
						form.data('formstatus', 'idle');
					},
					error: function() {
						console.error('Failed to add product to cart');
					}
				});
			}
			e.preventDefault();
			e.stopImmediatePropagation();
		});
	}

	addToCart() {
		$('#js-add-to-cart').on('click', function(e) {
			const $purchaseForm = $('#js-purchase-product');

			// Check the form is not currently submitting
			if ($purchaseForm.data('formstatus') !== 'submitting') {
				// Set up variables
				const form = $purchaseForm;
				const formData = form.serialize();
				const formUrl = form.attr('action').replace('^https?:', '');
				const formMethod = form.attr('method');
				const responseMessage = $('#js-purchase-message');
				const miniBasket = document.querySelector('x-mini-basket');
				const processingImage = $('#js-processing-purchase');
				const purchaseButton = $(this);
				const purchaseButtonText = purchaseButton.val();

				// Add status data to form
				form.data('formstatus', 'submitting');

				// Show processing message
				processingImage.show();
				purchaseButton.toggleDisabled().val('Processing...');
				responseMessage.html('').hide();

				// Send data to server for validation
				$.ajax({
					url: formUrl,
					type: formMethod,
					cache: false,
					data: formData,
					success: function(data) {
						if (data.search(/id="js-BASK"/i) != -1) {
							const responseMiniBasket = $(data).find('x-mini-basket')[0];
							const miniBasketCount = responseMiniBasket.getAttribute('count');
							const miniBasketSubtotal = responseMiniBasket.getAttribute('formatted-subtotal');
							const miniBasketCountElements = document.getElementsByClassName('js-mini-basket-count');
							for (const miniBasketCountElement of miniBasketCountElements) {
								miniBasketCountElement.innerText = miniBasketCount;
							}

							miniBasket.setAttribute('formatted-subtotal', miniBasketSubtotal);
							miniBasket.setAttribute('count', miniBasketCount);
							miniBasket.innerHTML = responseMiniBasket.innerHTML;

							miniBasket.open(MINI_BASKET_AUTOCLOSE_TIME, MINI_BASKET_AUTOCLOSE_AFTER_HOVER_TIME);

							// Re-Initialize Attribute Machine (if it is active)
							if (typeof window.attrMachCall !== 'undefined') {
								attrMachCall.Initialize();
							}

							form.find('.required').each(function() {
								if ($(this).hasClass('error')) {
									$(this).removeClass('error');
									$(this).parent('.form-row').find('.input').removeClass('error');
								}
							});

							// Klaviyo Add To Cart Tracking
							if (responseMiniBasket.getAttribute('data-klaviyo-atc')) {
								const klaviyoData = JSON.parse(atob(responseMiniBasket.getAttribute('data-klaviyo-atc')));

								if (typeof window._learnq === 'object' && klaviyoData) {
									klaviyoAddToCartTracking(klaviyoData);
								}

								// GTM addToCart Event fired when Ajax is successful / Hawksearch tracking
								if (klaviyoData) {
									window.dataLayer.push({
										ecommerce: null
									});

									const urlParams = new URLSearchParams(window.location.search);
									const gtmList = urlParams.get('list');
									const slugify = (text) => {
										return text?.toLowerCase().replace(/[^\w- ]+/g, '').replace(/ +/g, '-');
									}

									window.dataLayer.push({
										'event': 'add_to_cart',
										ecommerce: {
											add: {
												products: [
													{
														brand: klaviyoData.AddedItem_Brand,
														category: klaviyoData.AddedItem_Categories[0],
														id: klaviyoData.AddedItem_SKU,
														/* eslint-disable camelcase */
														item_brand: klaviyoData.AddedItem_Brand,
														item_id: klaviyoData.AddedItem_SKU,
														item_name: klaviyoData.AddedItemProductName,
														item_list_id: slugify(gtmList) || 'product-page',
														item_list_name: gtmList || 'product-page',
														item_category: klaviyoData.AddedItem_Categories[0],
														/* eslint-enable camelcase */
														name: klaviyoData.AddedItemProductName,
														currency: 'USD',
														price: klaviyoData.AddedItem_Price,
														quantity: klaviyoData.AddedItem_Quantity
													}
												]
											}
										},
										/* eslint-disable camelcase */
										ga_event_action: 'Add To Cart',
										ga_event_category: 'Ecommerce',
										ga_event_label: '',
										ga_event_noninteraction_hit: false,
										ga_event_value: ''
										/* eslint-enable camelcase */
									});

									// Hawksearch tracking
									addToCartTracking(klaviyoData.AddedItem_SKU, klaviyoData.AddedItem_Quantity, klaviyoData.AddedItem_Price);
								}
							}

							// Check for Ring Builder ATC
							if (form.find('[name="DID"]').val()) {
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									event: 'ga_event',
									/* eslint-disable camelcase */
									ga_event_action: 'Add to Cart',
									ga_event_category: 'Ring Builder',
									ga_event_label: 'Diamond & Setting',
									ga_event_non_interaction: false
									/* eslint-enable camelcase */
								});
							} else if (form.attr('ring-builder-setting')) {
								window.dataLayer = window.dataLayer || [];
								window.dataLayer.push({
									event: 'ga_event',
									/* eslint-disable camelcase */
									ga_event_action: 'Add to Cart',
									ga_event_category: 'Ring Builder',
									ga_event_label: 'Setting',
									ga_event_non_interaction: false
									/* eslint-enable camelcase */
								});
							}
						} else if (data.search(/id="js-PATR"/i) != -1) {
							const missingAttrs = [];
							form.find('.required').each(function() {
								missingAttrs.push(' ' + $(this).attr('title'));
								const missingInputValue = $(this).parent('.form-row').find('input,select,textarea').val();

								if (missingInputValue) {
									if ($(this).hasClass('error')) {
										$(this).removeClass('error');
										$(this).parent('.form-row').find('.input').removeClass('error');
									}
								} else {
									$(this).addClass('error');
									$(this).parent('.form-row').find('.input').addClass('error');
								}
							});
							responseMessage.html(`All <em class="red">Required</em> options have not been selected.<br />Please review the following options: <span class="red">${missingAttrs}</span>.`).fadeIn().delay(5000).fadeOut();
						} else if (data.search(/id="js-PLMT"/i) != -1) {
							responseMessage.html('We do not have enough stock to meet your request. Please adjust your quanity.').fadeIn().delay(3000).fadeOut();
						} else if (data.search(/id="js-POUT"/i) != -1) {
							responseMessage.html('The product you have selected is out of stock.<br />Please review your options or check back later.').fadeIn().delay(3000).fadeOut();
						} else {
							responseMessage.html('Please review options.').fadeIn().delay(3000).fadeOut();
						}

						// Hide processing message and reset formstatus
						processingImage.hide();
						purchaseButton.toggleDisabled().val(purchaseButtonText);
						form.data('formstatus', 'idle');
					},
					error: function() {
						console.error('Failed to add product to cart');
					}
				});
			}
			// Prevent form from submitting
			e.preventDefault();
			e.stopImmediatePropagation();
		});
	}

	imagemachineFallback() {
		// ---- Update Display Price Based on Attribute Selections (If Attribute Machine Is Not Being Used) ---- //
		var product_id = $('.product-price-value').data('prodid');
		if ((typeof attrMachCall === 'undefined') && (document.getElementById('js-product-attribute-count').value > 0) && (document.getElementById("js-price-value-" + product_id))) {

			for (var baseProductPrice = Number(document.getElementById("js-price-value-" + product_id).getAttribute("data-base-price")), regularProductPrice = Number(), productAttributeCount = Number(document.getElementById("js-product-attribute-count").value + 1), productAttributes = document.getElementById("js-purchase-product").elements, attributeType = [""], i = 0; i < productAttributes.length; i++) {
				var tagName = productAttributes[i].tagName.toLowerCase(),
					elementType = productAttributes[i].type,
					type = productAttributes[i].getAttribute("data-attribute-type"),
					name = productAttributes[i].name;
				"hidden" == elementType && null != type && attributeType.push(type);
				productAttributes[i].onchange = function() {
					updateProductDisplayPrice()
				}
			}

			function updateProductDisplayPrice() {
				for (var b, a, c = baseProductPrice, f = regularProductPrice, d = 1; d < productAttributeCount; d++)
					if (b = document.getElementsByName("Product_Attributes[" + d + "]:value"), "select" == attributeType[d])
						for (var e = 0; e < b.length; e++) a = b.item(e), a = a.options.item(a.selectedIndex), c += Number(a.getAttribute("data-option-price")), f += Number(a.getAttribute("data-regular-price"));
					else if ("radio" == attributeType[d] || "checkbox" == attributeType[d])
					for (e = 0; e < b.length; e++) a = b.item(e), a.checked && (c += Number(a.getAttribute("data-option-price")), f += Number(a.getAttribute("data-regular-price")));
				else if ("text" == attributeType[d] || "memo" == attributeType[d]) a = b.item(0), a.value && (c += Number(a.getAttribute("data-option-price")), f += Number(a.getAttribute("data-regular-price")));
				b = document.getElementsByName("Quantity");
				c *= Number(b.item(0).value);
				b.item(0);
				document.getElementById("js-price-value-" + product_id).innerHTML = formatCurrency(c);
				document.getElementById("js-mobile-price-value") && (document.getElementById("js-mobile-price-value").innerHTML = formatCurrency(c))
			}

			function formatCurrency(b) {
				var a = !1;
				0 > b && (a = !0, b = Math.abs(b));
				return (a ? "-$" : "$") + parseFloat(b, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString()
			}
			updateProductDisplayPrice();
		}
	}

	prodLoad() {
		// if has default variant, load variant data
		if(!mivaJS.Variant_ID) {
			return;
		}

		var product_code = mivaJS.Product_Code;
		var variant_id = mivaJS.Variant_ID;

		this.updateVariantData(product_code, variant_id, false);

	}

	variantChange() {
		const self = this;

		// ---- Update Display When Attribute Machine Fires ---- //
		MivaEvents.SubscribeToEvent('variant_changed', function({
			product_code,
			variant_id
		}) {
			//gallery.length = 0;
			//thumbnailIndex = 0;

			self.outOfStock();
			$('.custom-inventory--message').fadeOut();

			// Update Inventory Message based on Variant info
			const api_url = `${window.location.origin}/api.html`;

			self.updateVariantData(product_code, variant_id);

			$.ajax({
				url: api_url,
				type: 'GET',
				cache: false,
				data: {
					'get': 'inventory',
					'product_code': product_code,
					'variant_id': variant_id
				},
				success: function(data) {
					let invMessage = '';

					$.each(data, function(key, value) {
						if (value.inv_active === 1 && value.inv_available < 1 && value.preorder_message) {
							let preOrderMessage = value.preorder_message;
							let formattedPreOrderMessage = window.mivaJS?.PreOrderMessages?.find((message) => message.code === preOrderMessage);
							if (formattedPreOrderMessage?.message) {
								preOrderMessage = formattedPreOrderMessage.message;
							}
							invMessage = `<span class="custom-inventory--text custom-inventory--pre-order">${preOrderMessage}</span>`;
						} else if (value.inv_active === 1 && value.inv_level === 'low' && value.custom_message !== 'Cannot Backorder') {
							invMessage = key === 0 ? '<span class="u-color-primary-main_cta mr1" data-icon="&#x72;"></span><span class="custom-inventory--text">Out of stock. Please call <b><a href="tel:+4023910400">402.391.0400</a></b> for delivery estimates.</span>' : `<span class="u-color-primary-main_cta mr1" data-icon="&#x72;"></span><span class="custom-inventory--text">${invMessage} <br /> Out of stock. Please call <b><a href="tel:+4023910400">402.391.0400</a></b> for delivery estimates.</span>`;
						} else if (value.inv_active === 1 && value.inv_available === 1 && value.custom_message === 'Cannot Backorder') {
							invMessage = '<span class="u-color-primary-main_cta mr1" data-icon="&#x72;"></span><span class="custom-inventory--text">Only 1 Available.</span>';
						} else if (value.inv_active === 1 && value.inv_available < 1 && value.custom_message === 'Cannot Backorder') {
							invMessage = '<span class="custom-inventory--text">This item is currently out of stock. We can notify you when it becomes available again.</span>';
						}
					});

					if (invMessage !== '') {
						$('.product-information--inner .inventory-message').html('Special Order');
						$('.custom-inventory--message').html(invMessage);
						$('.custom-inventory--message').fadeIn();
					} else {
						$('.custom-inventory--message').html('');
						$('.custom-inventory--message').fadeOut();
					}

					const variantPart = data[0];
					let waitlistInventoryLevel = variantPart?.inv_level;
					// If less than 1 inventory, and Cannot Backorder, set to `out`
					if (variantPart.inv_active === 1 && variantPart.inv_instock < 1 && (variantPart.custom_message === 'Cannot Backorder' && !variantPart.preorder_message)) {
						waitlistInventoryLevel = 'out';
					}

					const waitlistForm = document.getElementById('js-waitlist-signup');
					if (waitlistForm) {
						waitlistForm.setAttribute('product-code', variantPart?.code);
						waitlistForm.setAttribute('stock-level', waitlistInventoryLevel);
						waitlistForm?.resetFields();
					}

					// Show + Hide ApplePay and "Call to Order"
					const showHideElements = document.getElementsByClassName('js-inventory-show-hide-element');
					for (const showHideElement of showHideElements) {
						if (waitlistInventoryLevel === 'out') {
							showHideElement.classList.add('all-hidden');
						} else {
							showHideElement.classList.remove('all-hidden');
						}
					}
				},
				error: function() {
					console.error('Failed to updated product inventory');
				}
			});

		});
	}

	getVariantData(product_code, variant_id, callback) {
		const api_url = `${window.location.origin}/api.html`;

		// Get Variant Data
		$.ajax({
			url: api_url,
			type: 'GET',
			cache: false,
			data: {
				'get': 'variant-data',
				'product_code': product_code,
				'variant_id': variant_id
			},
			dataType: 'json',
		}).done(function( data ) {
			callback(data);
		});
	}

	updateVariantData(product_code, variant_id, on_change = true) {
		var self = this;
		// If no variant ID add the variant id, otherwise update it
		if(window.location.href.indexOf('variant_id') == -1) {
			if(window.location.href.indexOf('?') == -1) {
				window.history.replaceState('','',`${window.location.href}?variant_id=${variant_id}`);
			} else {
				window.history.replaceState('','',`${window.location.href}&variant_id=${variant_id}`);
			}
		} else {
			const urlQueryString = window.location.search;
			const urlParams = new URLSearchParams(urlQueryString);

			if(urlParams.get('variant_id') !== variant_id) {
				//update the variant id
				const updatedVariantUrl = new URL(window.location.href);
				const variantURLParams = updatedVariantUrl.searchParams;
				variantURLParams.set('variant_id', variant_id);
				updatedVariantUrl.search = variantURLParams.toString();
				window.history.replaceState('','',updatedVariantUrl.toString());
			}
		}

		// Call to get updated variant data with callback to update the page
		self.getVariantData(product_code, variant_id, function(productVariant) {

			EventBus.dispatchEvent('PROD:getVariantData', productVariant);

			// Get elements to update
			const elementProductName = document.getElementById('js-product-title');
			const elementProductCode = document.getElementById('js-product-code');
			const elementProductDetails = document.getElementById('product_details');

			// Update global variant object
			window.mivaJS.currentVariant = {
				'id': variant_id,
				'code': productVariant.code,
				'sku': productVariant.sku,
				'name': productVariant.name,
				'description': productVariant.description,
				'image': productVariant.image,
			};

			// Update Metal + Overlays
			if (productVariant?.jewelry_refinement_material) {
				window.mivaJS.Product_Metal = productVariant?.jewelry_refinement_material;
			}

			const diamondOverlays = document.getElementsByClassName('js-diamond-overlay');
			for (const diamondOverlay of diamondOverlays) {
				diamondOverlay.setAttribute('metal', window.mivaJS.Product_Metal);
				diamondOverlay.setAttribute('product-code', typeof window.mivaJS?.currentVariant?.code !== 'undefined' ? window.mivaJS?.currentVariant?.code : window.mivaJS?.Product_Code);
			}

			const diamondPreviews = document.getElementsByClassName('js-rb-diamond-preview');
			for (const diamondPreview of diamondPreviews) {
				diamondPreview.setAttribute('product-code', productVariant.code);
			}

			// Update elements on load
			if(elementProductDetails) {
				elementProductDetails.innerHTML = productVariant.product_details;
				self.earringSizeChartModal();
				self.tennisSizeChartModal();
				self.studsSizeChartModal();
			}

			// Klaviyo updates
			if(typeof(kv_item) !== 'undefined')
			{
				let kv_variant_update = {
					'ProductName': productVariant.name,
					'ProductID': productVariant.code,
					'SKU': productVariant.sku,
					'ImageURL': productVariant.image,
					'URL': window.location.href,
					'Brand': productVariant.brand,
					'Price': productVariant.price
				};

				// Update object with variant data
				kv_item = Object.assign(kv_item, kv_variant_update);

				// Push viewed product variant event
				_learnq.push(["track", "Viewed Product Variant", kv_item]);
			}

			// Also update on change
			if(on_change) {
				if (document.title && productVariant.name) {
					let newTitle = productVariant.name + ' | Borsheims';

					// Only show vendor_item_no if brand is not "borsheims"
					if (productVariant.brand.toLowerCase() !== 'borsheims' && productVariant.vendor_item_no) {
						newTitle = productVariant.name + ' | ' + productVariant.vendor_item_no + ' | Borsheims';
					}

					document.title = newTitle;
				}
				elementProductName.innerHTML = productVariant.name;
				elementProductCode.innerText = 'SKU: ' + productVariant.sku;

				// GTM DataLayer Updates
				dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
				dataLayer.push({
					'ecommerce': {
						'detail': {
						'products': [{
							'name': productVariant.name,         // Name or ID is required.
							'id': productVariant.code,
							'price': productVariant.price,
							'brand': productVariant.brand,
							'sku': productVariant.sku,
							'variant': ''
						}]
						}
					}
				});
			}
		});

		var replaceUrlParam = function(url, paramName, paramValue)
		{
			if (paramValue == null) {
				paramValue = '';
			}
			var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
			if (url.search(pattern)>=0) {
				return url.replace(pattern,'$1' + paramValue + '$2');
			}
			url = url.replace(/[?#]$/,'');
			return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
		}
	}

	outOfStock() {
		const $button = $('#js-add-to-cart');
		const buttonText = $button.val();

		if ($button.is(':disabled') === true) {
			$button.addClass('bg-gray').val('Sold Out');
		} else {
			$button.removeClass('bg-gray').val(buttonText);
		}
	}

	callToOrder() {
		$('#js-call-to-order').magnificPopup({
			items: {
				type: 'inline',
				src: '#js-call-to-order-modal'
			},
			callbacks: {
				open: function() {
					document.getElementById('js-call-to-order--telephone').click();
				}
			}
		});
	}

	/**
	 * Logic for the wishlist buttons on PROD and PROD_FAMILY
	 */
	wishlistButtons() {
		/*
		Product Page & Family: Wishlist

		Requires 3 data attributes
		Button: data-wishlist-button
		Parent Container: data-wishlist-container
		ADPR Form: data-wishlist-form
		*/
		var wishlistButtons = document.querySelectorAll('[data-wishlist-button]');

		wishlistButtons.forEach(function(button) {
			var wishlistContainerElement = button.parentElement;
			var wishlistFormElement;

			// Find parent container
			while (typeof wishlistContainerElement.dataset.wishlistContainer === 'undefined') {
				wishlistContainerElement = wishlistContainerElement.parentElement;
			}

			// Find form within parent container
			wishlistFormElement = wishlistContainerElement.querySelector('[data-wishlist-form]');

			if (wishlistFormElement === null) {
				console.error('Could not find a wishlist form element for `' + button.classList.value + '`.');
				return;
			}

			button.addEventListener('click', function() {
				// Set form action and update action input
				wishlistFormElement.setAttribute('action', window.mivaJS.urls.wish);
				wishlistFormElement.elements.Action.value = 'ATWL';

				wishlistFormElement.submit();
			});
		});
	}

	// Drop a Hint form
	dropAHint() {
		const buttons = document.querySelectorAll('.drop-hint--trigger');

		buttons.forEach(function(button) {
			const dropAHintForm = button.nextElementSibling;

			// Check if the next element is the form
			if (dropAHintForm === null || !dropAHintForm.classList.contains('drop-hint-form')) {
				console.error('Could not find a drop a hint form element for `' + button.classList.value + '`.');
				return;
			}

			const formModal = new FormModal({
				trigger: button,
				template: dropAHintForm,
			});

			formModal.onTemplateAdded(function(){

				// Get variant data
				const product_variant = window.mivaJS.currentVariant;
				const template = formModal.getTemplateElement();
				const templateForm = template.querySelector('#drop-hint--form');

				templateForm.elements['Product_Name'].value = product_variant.name;
				templateForm.elements['Product_Code'].value = product_variant.code;
				templateForm.elements['Product_Image'].value = product_variant.image;
			});

			formModal.onSubmit(function(event) {
				const form = $(event.currentTarget);
				const formUrl = form.attr('action');
				const formMethod = form.attr('method');

				// Prevent form from submitting
				event.preventDefault();

				if (form.data('status') !== 'submitting') {
					const formData = form.serializeArray();
					form.data('status', 'submitting');

					formData.push({
						name: "ajax",
						value: 1
					});

					$.ajax({
						url: formUrl,
						type: formMethod,
						cache: false,
						data: $.param(formData),
						success: function(data) {
							var formattedHTML = '';

							$.each(data, function(key, value) {
								var status = value.status,
									message = value.message;

								if (status == 200) {
									// Success
									formattedHTML += '<p class="message message-info">' + message + '</p>';
									form.find('input[type="text"], input[type="email"], input[type="tel"], textarea, select').val('');
								} else {
									// Error
									formattedHTML += '<p class="message message-error">' + message + '</p>';
								}
							});

							form.find('.response-message').html(formattedHTML).fadeIn(200);
							form.data('status', 'idle');
						},
						error: function() {
							console.error("Failed to submit form");
						}
					});
				};
			});
		});
	};

	/**
	 * Request Appointment Form
	 * Submit users information to the sever using AJAX. Will
	 * display either a error or success message.
	 */
	requestAppointment() {
		const formModal = new FormModal({
			trigger: document.querySelector('.request-appointment-button'),
			template: document.querySelector('#request-appointment-form'),
		});

		formModal.onSubmit(function(event) {
			const DELAY = 5000;
			const form = event.currentTarget;

			event.preventDefault();

			$.ajax({
					url: window.location.href,
					method: 'post',
					data: $(form).serialize()
				})
				.done(function(data) {
					var parser = new DOMParser();
					var responseDocument = parser.parseFromString(data, 'text/html');
					var responseTemplate = responseDocument.getElementById('request-appointment-form');
					var responseTemplateElement;

					// Get contents of the template
					responseTemplateElement = document.documentElement.classList.contains('ie') ?
						responseTemplate.firstElementChild :
						responseTemplate.content.firstElementChild;

					const messageElement = formModal.getTemplateElement().querySelector('#js-form--request_appointment_form .message');
					const responseMessageElement = responseTemplateElement.querySelector('#js-form--request_appointment_form .message');

					// Replace the message element with the message element from the response
					messageElement.parentElement.replaceChild(responseMessageElement, messageElement);

					window.setTimeout(function() {
						// Hide message
						messageElement.classList.add('hide');

						// If form submission is successful reset the form and close the modal

						if (messageElement.classList.contains('message-success') !== null) {
							// Reset Form
							form.reset();

							// Close modal
							$.magnificPopup.instance.close();
						}
					}, DELAY);
				})
				.fail(function() {
					const messageElement = formModal.getTemplateElement().querySelector('#js-form--request_appointment_form .message');

					// Display message
					if (messageElement.classList.contains('hide')) {
						messageElement.classList.remove('hide');
					}

					// Error message
					messageElement.classList.add('message-error');
					messageElement.textContent('Failed to submit form. Please try again later.');

					// Hide Message
					window.setTimeout(function() {
						messageElement.classList.add('hide');
					}, DELAY);
				});
		});
	};

	/**
	 * Product details form which allows the customer to get more information
	 * about a specific product
	 */
	productDetailsForm() {
		const formModal = new FormModal({
			trigger: document.querySelector('.email-us--trigger'),
			template: document.querySelector('#js-details-modal'),
		});

		formModal.onTemplateAdded(function(){

			// Get variant data
			const product_variant = window.mivaJS.currentVariant;
			const template = formModal.getTemplateElement();
			const templateForm = template.querySelector('#js-details-form');

			templateForm.elements['Product_Name'].value = product_variant.name;
			templateForm.elements['Product_Code'].value = product_variant.code;
		});

		formModal.onSubmit(function(event) {
			const DELAY = 5000;
			const $form = $(event.currentTarget);
			const formData = $form.serializeArray();

			formData.push({
				name: "ajax",
				value: 1
			});

			$form.data('formstatus', 'submitting');

			$.ajax({
					url: $form.attr('action'),
					type: $form.attr('method'),
					data: $.param(formData),
				})
				.done(function(data) {
					var formattedHTML = '';

					$.each(data, function(key, value) {
						var status = value.status,
							message = value.message;

						if (status == 200) {
							// Success
							formattedHTML += '<p class="message message-info">' + message + '</p>';
							$form.find('input[type="text"], input[type="email"], input[type="tel"], textarea, select').val('');
						} else {
							// Error
							formattedHTML += '<p class="message message-error">' + message + '</p>';
						}
					});

					$form.find('.response-message').html(formattedHTML).fadeIn(200);

					$form.data('status', 'idle');
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					$form.data('formstatus', 'idle');
				})
				.always(function() {
					$form.find('.response-message .message-info').delay(DELAY).fadeOut(200);
				});

			// Prevent form from submitting
			event.preventDefault();
			event.stopImmediatePropagation();
		});
	};

	async productImageGallery () {
		const {default: ProductImageGallery} = await import('extensions/product-image-gallery');

		new ProductImageGallery();
	}
}
